import { Injectable } from "@angular/core";
import { Observable, of } from "rxjs";
import { catchError } from "rxjs/operators";

import { environment } from "src/environments/environment";
import { ApiEnum, HttpDataService } from "./http-data.service";

/** Un mes de actividad de la plataforma (accesos registrados). */
export interface ActividadMensual {
	anyo: number;
	mes: number;
	numAccesos: number;
}

/**
 * KPIs globales de la landing (GET /Home/Kpis). Conteos SIN scoping por usuario
 * (cacheados en servidor): la home muestra la dimensión real de la plataforma.
 */
export interface HomeKpis {
	contratos: number;
	centros: number;
	actividades: number;
	paises: number;
	/** Últimos 12 meses cerrados (sin el actual), siempre 12 entradas. */
	actividadMensual: ActividadMensual[];
}

export interface CentroImagen {
	centroId: number;
	imageDataB64: string;
}

/**
 * Datos de la landing: KPIs globales + imágenes efectivas de las cards de
 * "Tus centros" (centro → contrato, resuelto en servidor en una sola llamada
 * para evitar la cascada de 404 por card). Tolerante a fallos: resuelve
 * vacío/null para no romper la pantalla.
 */
@Injectable({ providedIn: "root" })
export class HomeKpisService {
	constructor(private readonly httpDataService: HttpDataService) {}

	getKpis(): Observable<HomeKpis | null> {
		return this.httpDataService
			.get$<HomeKpis>(ApiEnum.API_ROOT, environment.endpoint.home.kpis)
			.pipe(catchError(() => of(null)));
	}

	getImagenesCentros(ids: number[]): Observable<CentroImagen[]> {
		if (!ids?.length) {
			return of([]);
		}
		const url = `${environment.endpoint.home.imagenesCentros}?ids=${ids.join(",")}`;
		return this.httpDataService
			.get$<CentroImagen[]>(ApiEnum.API_ROOT, url)
			.pipe(catchError(() => of([] as CentroImagen[])));
	}
}
